import { render, staticRenderFns } from "./Reg1024.vue?vue&type=template&id=0c78a9bc"
import script from "./Reg1024.vue?vue&type=script&lang=js"
export * from "./Reg1024.vue?vue&type=script&lang=js"
import style0 from "./Reg1024.vue?vue&type=style&index=0&id=0c78a9bc&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports